import { BriefingsAboutData } from "content-ui/briefings/fetchers/briefingsAboutFetcher";
import VideoPlayer from "components/videoPlayer/videoPlayer";

type VideoSectionProps = Pick<
  BriefingsAboutData,
  "video" | "videoParagraph" | "videoHeading"
>;

export const VideoSection = ({
  video,
  videoParagraph,
  videoHeading,
}: VideoSectionProps) => {
  return (
    <div className={"block py-[70px] text-center"}>
      {videoHeading && (
        <h2 className="mb-2 block font-recklessBold text-[32px] leading-[130%]">
          {videoHeading}
        </h2>
      )}
      {videoParagraph && (
        <p
          className={
            "mx-auto mb-[30px] block max-w-[400px] text-[14px] text-mono-40"
          }
        >
          {videoParagraph}
        </p>
      )}
      {video && (
        <div
          data-testid={"video"}
          className={
            "relative mx-auto mt-[30px] block h-full w-full max-w-[830px]"
          }
        >
          <VideoPlayer url={video.url} />
        </div>
      )}
    </div>
  );
};

export default VideoSection;
